














































import Vue from "vue";
import { Portal } from "@infoland/iprova-api";
import _ from "lodash";
import shared from "../shared";

export default Vue.extend({
    name: "PortalGroupedList",
    components: {},
    props: {
        portalGroups: Array,
        hasHref: Boolean
    },
    data: () => ({}),
    methods: {
        redirectToSelectedPortal(portalItem: any) {
            this.$emit("portal-selected-changed", portalItem);
        },
        getRedirectToPortalUrl(portalId: Number): String {
            const routeData = this.$router.resolve({ name: "Portal", params: { portalId: portalId.toString() } });
            return routeData.href;
        },
        getPortalGroupsList(): Array<any> {
            const portalGroupsResult = _(this.portalGroups)
                .groupBy("portal_group.order")
                .orderBy("key")
                .map(portalGroupGrouping => {
                    const firstPortalInGroup = _.first(portalGroupGrouping).portal_group;
                    const portalGroupId = firstPortalInGroup.portal_group_id;
                    const name = firstPortalInGroup.name;
                    const order = firstPortalInGroup.order;

                    const portals = _.map(portalGroupGrouping, portal => {
                        return {
                            id: portal.portal_id,
                            title: portal.name
                        };
                    });

                    return {
                        portalGroupId,
                        name,
                        order,
                        portals
                    };
                })
                .valueOf();

            return portalGroupsResult;
        }
    }
});
